async function getAppVersion() {
  return `8.15.1`;
}

export { getAppVersion };
